"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CookieNotice_vue_1 = __importDefault(require("maya-cookie-notice-vue/dist/CookieNotice.vue"));
window.dataLayer = window.dataLayer || [];
function gtag(command, ...parameters) {
    window.dataLayer.push(command, ...parameters);
}
exports.default = {
    extends: CookieNotice_vue_1.default,
    methods: {
        handleAcceptedStatistic() {
            if (typeof gtag !== 'undefined' && gtag) {
                gtag('consent', 'update', {
                    analytics_storage: 'granted',
                    wait_for_update: 500,
                    region: ['GB'],
                });
            }
        },
        handleRejectedStatistic() {
            if (typeof gtag !== 'undefined' && gtag) {
                gtag('consent', 'update', {
                    analytics_storage: 'denied',
                    wait_for_update: 0,
                    region: ['GB'],
                });
            }
        },
    },
};
